import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import cartReducer from './cartSlice'; // If built in Phase 3
import orderReducer from './orderSlice'; // If built in Phase 4
import shippingReducer from './shippingSlice'; // If built in Phase 5
import adminReducer from './adminSlice'; // If built in Phase 6

const store = configureStore({
    reducer: {
        auth: authReducer,
        cart: cartReducer,
        orders: orderReducer,
        shipping: shippingReducer,
        admin: adminReducer
    }
});

export default store;